import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //
  // Strictnode enabled outside browserrouter, which was the default way, didn't let the route switch , does not render componenets and 
  <BrowserRouter>
  <React.StrictMode> 
    <App />
	</React.StrictMode>
	</BrowserRouter> 
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
